module.exports = __webpack_public_path__ + "img/589-42dfb3.png";